import { useQuery } from "react-query";
import { getAllWallets } from "services/walletAdmin.service";

export default function useAllWallets(params?: { page?: number; limit?: number }) {
  return useQuery(["all-wallets", params], () => getAllWallets(params), {
    keepPreviousData: true,
  });
}
